import i18n from '@/language/i18n';

const YES_OR_NO = Object.freeze([
  { text: i18n.t('Common.yes'), value: 'true' },
  { text: i18n.t('Common.no'), value: 'false' },
]);

const formatAttributeValues = (attributes) => {
  if (!attributes) return attributes;
  let keyValueStrings = [];
  for (let item of Object?.entries(attributes)) {
    let itemValues = [];
    item[1].values.forEach((itemVal) =>
      itemValues.push(
        YES_OR_NO.find((status) => status.value == itemVal)?.text ?? itemVal
      )
    );
    keyValueStrings.push({ 
      value: `${item[1].label}: ${itemValues.join(', ')}`,
      type: item[1].type 
    });
  }

  return keyValueStrings;
}

export { formatAttributeValues };
